import { Route, Switch, useHistory } from 'react-router-dom';
import { useEffect } from 'react'
import { setUser } from "./reducers/userReducer"
import Home from './components/Home'
import Auth from './components/Auth'
import { useDispatch, useSelector } from 'react-redux';
import { getAuth, signOut } from "firebase/auth";
import Lobby from './components/game/Lobby'
import Room from './components/game/Room';
import Loading from './components/game/Loading';

function App() {
  const user = useSelector(state => state.user)
  const dispatch = useDispatch();
  const history = useHistory();

  // check whether use Logged in
  useEffect(() => {
    const unregisterAuthObserver = getAuth().onAuthStateChanged(user => {
      dispatch(setUser(getAuth().currentUser))
    })
    return () => unregisterAuthObserver()
  }, [dispatch])

  return (
    <div className="container">
      <div>
        {user != null
          ? <button onClick={() => signOut(getAuth())}>Sign-out</button>
          : null}
        <button onClick={() => history.push('/')}>home</button>
      </div>
      <Switch>
        <Route path="/home">
          <Home />
        </Route>
        <Route path="/lobby">
          <Lobby />
        </Route>
        <Route path="/loading">
          <Loading />
        </Route>
        <Route path="/room">
          <Room />
        </Route>
        <Route path="/">
          <Auth />
        </Route>
      </Switch>
    </div>
  );
}

export default App;
